export function oneOf (value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/assest.js